export const throttle = (func: (...args) => unknown, wait: number) => {
  let time = 0;
  return function (...args: unknown[]) {
    if (Date.now() - time < wait) return;
    time = Date.now();
    func(...args);
  };
};
